import { useCustomerPopup } from "@/components/CustomerPopup";
import { Icon, IconName } from "@/components/Icon";
import { Marquee, MarqueeItem} from "@/components/Marquee";
import { PageLayout } from "@/components/PageLayout";
import { ScanPopup } from "@/components/ScanPopup";
import {
  FuncAction,
  exchangeActions,
  funcActions,
  isSale,
  myOrdersColumns,
  myTradesColumns,
} from "@/constants/order/key";
import { CapsuleTabs, Grid, Space, Swiper, Tabs } from "antd-mobile";
import { useNavigate } from "react-router-dom";
import BalanceDetail from "./BalanceDetail";
import BalanceInfo from "./BalanceInfo";
import Header from "./Header";
import ListTable from "./components/ListTables";
import styles from "./index.module.scss";
import { useLogic } from "./logic";
import { ErType } from "@/constants/order/key";
import { EarnIcon } from "./components/EarnIcon";
import { useEffect, useState } from "react";
import { HomeCarousel } from "./HomeCarousel";
import { useCryptoMerchantInfoStore } from "@/stores/CryptoMerchatStore";

export function PageHome(props: any) {
  const [customerPopup] = useCustomerPopup();
  const {getCryptoMerchantInfo} = useCryptoMerchantInfoStore();
  const navigate = useNavigate();
  const logic = useLogic();
  const [loading, setLoading] = useState<boolean>(false);
  const doAction = (action: FuncAction) => {
    switch (action.action) {
      case "scan":
        // navigate("/scan");
        break;
      case "help":
        navigate("/helps");
        break;
      case "payment":
        navigate("/payment");
        break;
      case "custrom":
        customerPopup();
        break;
    } 
  };
  const onRefresh = () => {
    setLoading(true);
    getCryptoMerchantInfo();
    logic.updateUserInfo().finally(() => {
      setLoading(false)
    })
  }

  useEffect(()=>{
    onRefresh();
  },[])

  return (
    <PageLayout>
      <div className={styles.content}>
        <section className={styles.header}>
          <Header />
        </section>
        <section className={styles.balance_tabs}>
          <Tabs activeLineMode={"auto"}>
            <Tabs.Tab title="账号余额" key={"balance_info"}>
              <BalanceInfo userInfo={logic.userInfo} loading={loading} onRefresh={onRefresh}/>
            </Tabs.Tab>
            <Tabs.Tab title="余额详情" key={"balance_detail"}>
              <BalanceDetail userInfo={logic.userInfo} />
            </Tabs.Tab>
          </Tabs>
        </section>
        <Grid columns={4} gap={8} className={styles.exchangeActions}>
          {exchangeActions.map((action) => {
            return (
              <Grid.Item
                className={styles.exchangeActionItem}
                key={action.action}
                onClick={() =>
                  navigate(action.to as string, { replace: !!action.replace })
                }
              >
                <div className={styles.exchangeActionIcon}>
                  <Icon name={action.icon as IconName} size="24px" />
                </div>
                <div className={styles.exchangeActionText}>{action.text}</div>
              </Grid.Item>
            );
          })}
        </Grid>
        <Space className={styles.notice}>
          {/* <Marquee icon={<Icon name={"global_notice"} size={"0.16rem"} />}>
            {logic.announcements.length ? `${logic.announcements[0]}${logic.announcements[0]}${logic.announcements[0]}${logic.announcements[0]}${logic.announcements[0]}${logic.announcements[0]}` : ""}
          </Marquee> */}
          <MarqueeItem icon={<Icon name={"global_notice"} size={"0.16rem"} />} list={logic.announcements}/>
        </Space>
        <Grid columns={4} gap={6} className={styles.funcActions}>
          {funcActions.map((action) => {
            return (
              <Grid.Item
                className={styles.funcActionsItem}
                key={action.action}
                onClick={() => action.action !== "scan" && doAction(action)}
              >
                {action.action === "scan" ? (
                  <>
                    <ScanPopup>
                      <div className={styles.funcActionIcon}>
                        <Icon name={action.icon as IconName} size="30px" />
                      </div>
                      <div className={styles.funcActionText}>{action.text}</div>
                    </ScanPopup>
                  </>
                ) : (
                  <>
                    <div className={styles.funcActionIcon}>
                      <Icon name={action.icon as IconName} size="30px" />
                    </div>
                    <div className={styles.funcActionText}>{action.text}</div>
                  </>
                )}
              </Grid.Item>
            );
          })}
        </Grid>
        <HomeCarousel />
        <CapsuleTabs className={styles.order_list} onChange={logic.onTabChange}>
          <CapsuleTabs.Tab
            key={1}
            title={
              <div className={styles.order_list_action_left}>我的挂单</div>
            }
          >
            <ListTable
              columns={myOrdersColumns}
              data={logic.orderList}
              total={logic.orderTotal}
              onMoreClick={() => {
                navigate("/my_pending_orders");
              }}
              onRowClick={(row) => {
                navigate(`/selling/${row.pendingOrderId}?m=${row.sellerType ===ErType.Business ?1:0}`);
              }}
            />
          </CapsuleTabs.Tab>
          <CapsuleTabs.Tab
            key={2}
            title={
              <div className={styles.order_list_action_right}>交易记录</div>
            }
          >
            <ListTable
              columns={myTradesColumns}
              data={logic.tradeList}
              total={logic.tradeTotal}
              restData={{ userInfo: logic.userInfo }}
              onMoreClick={() => {
                navigate("/root/orders?type=normal");
              }}
              onRowClick={(row) => {
                const sale = isSale(row, { userInfo: logic.userInfo });
                navigate(
                  `/${sale ? "sell_trading" : "buy_trading"}/${row.orderId}?m=${row.sellerType ===ErType.Business ?1:0}`
                );
              }}
            />
          </CapsuleTabs.Tab>
        </CapsuleTabs>


        <div className={styles.space}></div>
      </div>
      <EarnIcon />
      {logic.renderSwiper()}
    </PageLayout>
  );
}
